import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = (adjustLogoToHeight?: boolean) =>
  makeStyles(() =>
    createStyles({
      container: {
        flexGrow: 1,
      },
      logo: {
        height: adjustLogoToHeight ? 50 : 28,
      },
      button: {
        "&:hover": {
          background: "none",
          cursor: "pointer",
        },
      },
    })
  );
